import { Component, effect, isDevMode, OnInit, TemplateRef, ChangeDetectionStrategy, viewChild } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { TranslocoService } from '@jsverse/transloco'
import { AppInitService } from './app-init.service'
import { ModalService } from './services/modal.service'
import { SEOService } from './services/seo.service'
import { SiteConfigService } from './services/site-config.service'
import { WalletService } from './services/wallet.service'
import { DevToolsComponent } from './features/dev-tools/dev-tools.component'
import { ModalsComponent } from './shared/components/modals/modals.component'
import { AppModalComponent } from './shared/components/modals-v2/modal-v2/modal-v2.component'
import { SearchPanelComponent } from './features/search/components/search-panel/search-panel.component'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.css',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DevToolsComponent, RouterOutlet, ModalsComponent, AppModalComponent, SearchPanelComponent]
})
export class AppComponent implements OnInit {
	readonly sessionModalTemplate = viewChild<TemplateRef<unknown>>('sessionModalTemplate')

	public isDevMode = isDevMode()

	constructor(
		private siteConfigService: SiteConfigService,
		private appInitService: AppInitService,
		private modalService: ModalService,
		private router: Router,
		private seoService: SEOService,
		private translocoService: TranslocoService,
		private walletService: WalletService
	) {
		effect(() => {
			const isLoading = this.appInitService.isLoading()
			const success = this.appInitService.successStatus()
			if (isLoading) {
				this.modalService.setLoading('default', true)
			} else {
				this.modalService.setLoading('default', false)
			}

			// Init app init success
			if (success) {
				this.seoService.init(this.siteConfigService.config)
				this.modalService.close('default')
				this.router.navigate(['/'])
			}
		})
	}

	async ngOnInit(): Promise<void> {
		// Handle app init error
		if (this.appInitService.initError()) {
			this.handleInitError()
		}
	}

	handleInitError(): void {
		this.modalService.open('default', {
			title: 'Something went wrong',
			body: 'Failed to initialize the application.',
			options: { closable: false, confirm: true, confirmText: 'Retry' }
		})

		this.modalService.onClick('default', async (isConfirmed: boolean) => {
			if (isConfirmed) {
				this.appInitService.retryAppLoad()
			}
		})
	}
}
